/// <reference path="../../../../../../typings/index.d.ts" />

module Meevo.Components.Controls {
    "use strict";

    export class SmartTilePropSalesType implements angular.IComponentOptions {
        templateUrl = "app/components/controls/smartCenterDesigner/propertyViews/smartTilePropSalesType.component.html";
        bindings: any = {
            prop: '=?',
            selectionChanged: '&?'
        };
        controller = class SmartTilePropSalesTypeController {
            static $inject = [
                "meevo.components.common.DataService",
                "$translate"
            ];

            public prop: Meevo.Model.SmartTileParameter;
            public selectedItem: Model.EnumDto;
            public salesTypes: Model.EnumDto[] = [];
            public selectionChanged: Function;

            constructor(
                protected dataService: Components.BaseClasses.IDataService,
                protected $translate: angular.translate.ITranslateService
            ) {
            }

            $onInit(): void {
                this.dataService.getEnumList(Model.EnumTypeEnum.SalesTypeEnum).then(salesTypes => {
                    this.salesTypes = [];
                    if (this.prop.includedValues) {
                        const included = this.prop.includedValues.split(',').map(item => item.trim());
                        if (included.indexOf('All') !== -1) {
                            this.salesTypes.push({
                                value: 'All',
                                displayName: ''
                            });
                        }
                        salesTypes = salesTypes.filter(val => included.indexOf(val.value) !== -1);
                    }
                    this.salesTypes = this.salesTypes.concat(salesTypes);
                    if (this.prop) {
                        this.selectedItem = _.findWhere(this.salesTypes, { value: this.prop.parameterValue });
                    }
                });
            }

            getDisplayName(salesType) {
                switch (salesType.value) {
                    case 'Service':
                        return this.$translate.instant("LABEL_SERVICE");
                    case 'Product':
                        return this.$translate.instant("LABEL_PRODUCT");
                    case 'GiftCard':
                        return this.$translate.instant("LABEL_GIFT_CARD");
                    case 'Package':
                        return this.$translate.instant("LABEL_PACKAGE");
                    case 'Membership':
                        return this.$translate.instant("LABEL_MEMBERSHIP");
                    case 'All':
                        return this.$translate.instant("LABEL_OVERALL_SALES");
                }
            }

            onSelectionChanged(): void {
                this.prop.parameterValue = this.selectedItem.value;
                this.prop.parameterDisplayName = this.selectedItem.displayName;
                this.selectionChanged({ selection: this.selectedItem });
            }
        }
    }

    angular.module("meevo.components.controls")
        .component("stpSalesType", new SmartTilePropSalesType());
}
